import { Building, Trash2 } from "lucide-react";

import { useUserProfile } from "@/api/users-query";
import { AddBankDialog } from "@/components/bank/bank-dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function BankSection() {
	const profile = useUserProfile();

	return (
		<Card className="space-y-4 shadow-none">
			<CardHeader>
				<h3 className="text-lg ">Add bank</h3>
				<p className="text-sm text-muted-foreground">Link your bank accounts</p>
			</CardHeader>
			<CardContent className="space-y-4">
				<div className="flex gap-4">
					{
						profile.data?.bankAccounts?.length === 0
							? (
									<div className="w-full flex flex-col items-center justify-center space-y-1">
										<img src="/no-bank.svg" alt="No Bank accounts" className="bg-red-200 rounded-full aspect-square" />
										<p className="text-lg font-semibold">No Bank Added</p>
										<span className="text-muted-foreground text-sm">
											Your added banks will
											appear here
										</span>
									</div>
								)
							: profile.data?.bankAccounts?.map(account => (
								<div key={account.id} className="flex flex-col gap-2 items-center">
									<div className="group relative size-14 bg-zinc-100 cursor-pointer hover:bg-zinc-300 rounded-full flex items-center justify-center">
										<Building className="size-6 text-zinc-400" />
										<Trash2 className="absolute hidden  top-1/2 transform -translate-y-1/2 size-6 text-red-500 group-hover:block" />
									</div>
									<p className="text-sm capitalize truncate w-20">{account.bank.bankName.toLowerCase()}</p>
								</div>
							))
					}
				</div>
				<div className="flex justify-center gap-2">
					<AddBankDialog />
					<Button className="gap-1 h-12" variant="secondary">
						<span>Manage</span>
					</Button>
				</div>
			</CardContent>
		</Card>
	);
}
